export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0009.a4096ea8.webp";